import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PhaseSelect from './PhaseSelect';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import isTouchDevice from '@/lib/utils/isTouchDevice';

// This is necessary because dragging cards doesn't work on non-mouse devices
const MobilePhaseSelect = () => {
  if (!isTouchDevice()) {
    return null;
  }

  return (
    <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
      <PhaseSelect />
    </RestrictedToPortfolioMode>
  );
};

export default MobilePhaseSelect;
